import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

const INVOZIO_EMPLOYER = {
  company: 'Invozio LV SIA',
  organisationNumber: '5020854062',
  address: 'Ahtri 12',
  zipCode: '10151',
  country: 'Estonia',
  phoneNumber: '010-264 88 10',
};

interface InfoFieldProps {
  label: string;
  value: string;
}

const InfoField: React.FC<InfoFieldProps> = ({ label, value }) => (
  <div className="ec-field-group">
    <label className="ec-field-label">{label}</label>
    <input className="ec-field-input" value={value} disabled readOnly />
  </div>
);

export const EmployerInfoSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="ec-section-card">
      <h3 className="ec-section-title">{t('EMPLOYER_INFORMATION') || 'Employer Information'}</h3>
      <Row>
        <Col md={4}>
          <InfoField label={t('COMPANY') || 'Company'} value={INVOZIO_EMPLOYER.company} />
        </Col>
        <Col md={4}>
          <InfoField label={t('ORGANISATION_NUMBER') || 'Organisation Number'} value={INVOZIO_EMPLOYER.organisationNumber} />
        </Col>
        <Col md={4}>
          <InfoField label={t('ADDRESS') || 'Address'} value={INVOZIO_EMPLOYER.address} />
        </Col>
        <Col md={4}>
          <InfoField label={t('ZIP_CODE') || 'ZIP Code'} value={INVOZIO_EMPLOYER.zipCode} />
        </Col>
        <Col md={4}>
          <InfoField label={t('COUNTRY') || 'Country'} value={INVOZIO_EMPLOYER.country} />
        </Col>
        <Col md={4}>
          <InfoField label={t('PHONE_NUMBER') || 'Phone Number'} value={INVOZIO_EMPLOYER.phoneNumber} />
        </Col>
      </Row>
    </div>
  );
};
